import React from "react";
export const ProjectPageLazy = React.lazy(() => import("./index"));
